define([], ()=> {
    /**
     * Service for providing a set of helper functions across the application
     */
    return [()=> {
        let counter = 0;
        return {
            getUniqueID: ()=> {
                return counter++;
            },

            assert: (()=> {
                const assert = (value, message)=> {
                    if (!value) {
                        throw new Error(message || 'Failed assertion');
                    }
                };

                assert.string = (value, message)=> {
                    assert(value && typeof value === 'string', message || 'String expected');
                };

                assert.stringKey = (object, key, message)=> {
                    assert.string(object && object[key], message || `Expected ${key} to be a string`);
                };

                return assert;
            })()
        };
    }
    ];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/util/BaseUtil.js
 **/